import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export default function LeftArrowWithCircle({
  width = 40,
  height = 40,
  color = '#240089',
  className,
  ...rest
}: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={width}
      height={height}
      className={twMerge('', className)}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4697 13.4697C20.7626 13.1768 21.2374 13.1768 21.5303 13.4697L27.5303 19.4697C27.8232 19.7626 27.8232 20.2374 27.5303 20.5303L21.5303 26.5303C21.2374 26.8232 20.7626 26.8232 20.4697 26.5303C20.1768 26.2374 20.1768 25.7626 20.4697 25.4697L25.1893 20.75H13C12.5858 20.75 12.25 20.4142 12.25 20C12.25 19.5858 12.5858 19.25 13 19.25H25.1893L20.4697 14.5303C20.1768 14.2374 20.1768 13.7626 20.4697 13.4697Z"
        fill={color}
      />
      <path
        d="M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z"
        stroke={color}
      />
    </svg>
  );
}
